// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 643) return "js/app-legacy/pdfmake.js";
	if (chunkId === 265) return "js/app-legacy/canvg.js";
	if (chunkId === 297) return "js/app-legacy/xlsx.js";
	if (chunkId === 384) return "js/app-legacy/markerjs2.js";
	// return url for filenames based on template
	return undefined;
};